function renderDefaultValueContentTemplate({
  fName,
  targetValuesExpression,
  sourceValuesExpression,
  fallback
}: {
  fName: string
  targetValuesExpression: string
  sourceValuesExpression: string
  fallback: string
}): string {
  return `      ${fName}: ${targetValuesExpression}.length > 0
        ? ${targetValuesExpression}
        : ${sourceValuesExpression}.length > 0
          ? ${sourceValuesExpression}
          : ${fallback}`
}

function renderDefaultValueContentDetailsTemplate({
  fName,
  hasInitialValueExpression,
  dataSource,
  hasInitialValueExpressionText,
  sourceName,
  defaultFallbackValue
}: {
  fName: string
  hasInitialValueExpression: string
  dataSource: string
  hasInitialValueExpressionText: string
  sourceName: string
  defaultFallbackValue: string
}): string {
  return `      ${fName}: ${hasInitialValueExpression}
        ? ${dataSource}.${fName}
        : ${hasInitialValueExpressionText}
          ? (${dataSource}.${sourceName} as never)
          : ${defaultFallbackValue}`
}

function renderDefaultValueContentDetailsBranchTemplate({
  fName,
  dataSource
}: {
  fName: string
  dataSource: string
}): string {
  return `      ${fName}: ${dataSource}?.${fName}
        ? (typeof ${dataSource}?.${fName} === 'object' ? String(${dataSource}?.${fName}.id) : String(${dataSource}?.${fName}))
        : ''`
}

function renderDefaultValueContentDetailsBranchBodyTemplate({
  fName,
  selectedValuesExpression,
  validValuesExpression,
  fallback
}: {
  fName: string
  selectedValuesExpression: string
  validValuesExpression: string
  fallback: string
}): string {
  return `      ${fName}: ${selectedValuesExpression}.length > 0
        ? ${selectedValuesExpression}.filter((value) => ${validValuesExpression}.includes(value))
        : ${fallback}`
}

export function renderDefaultValueRenderer(
  request:
    | {
        kind: 'renderDefaultValueContentTemplate'
        props: {
          fName: string
          targetValuesExpression: string
          sourceValuesExpression: string
          fallback: string
        }
      }
    | {
        kind: 'renderDefaultValueContentDetailsTemplate'
        props: {
          fName: string
          hasInitialValueExpression: string
          dataSource: string
          hasInitialValueExpressionText: string
          sourceName: string
          defaultFallbackValue: string
        }
      }
    | {
        kind: 'renderDefaultValueContentDetailsBranchTemplate'
        props: {
          fName: string
          dataSource: string
        }
      }
    | {
        kind: 'renderDefaultValueContentDetailsBranchBodyTemplate'
        props: {
          fName: string
          selectedValuesExpression: string
          validValuesExpression: string
          fallback: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderDefaultValueContentTemplate':
      return renderDefaultValueContentTemplate(request.props)
    case 'renderDefaultValueContentDetailsTemplate':
      return renderDefaultValueContentDetailsTemplate(request.props)
    case 'renderDefaultValueContentDetailsBranchTemplate':
      return renderDefaultValueContentDetailsBranchTemplate(request.props)
    case 'renderDefaultValueContentDetailsBranchBodyTemplate':
      return renderDefaultValueContentDetailsBranchBodyTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
